import { Injectable } from '@angular/core';
import { ParamMap } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class WebviewService {
    isWebView: boolean = false;
    source: WebviewSource;
    helpedID: string;
    constructor() { }

    set(url: ParamMap): void {
        this.isWebView = url.has(WebviewAvailableParams.webview);
        if (this.isWebView && url.get(WebviewAvailableParams.webview)?.includes(WebviewSource.android) || url.get(WebviewAvailableParams.webview)?.includes(WebviewSource.ios)) {
            this.source = url.get(WebviewAvailableParams.webview).includes(WebviewSource.android) ? WebviewSource.android : WebviewSource.ios;
        }
        if (url.has(WebviewAvailableParams.userID)) {
            this.helpedID = url.get(WebviewAvailableParams.userID);
        }
    }
}
enum WebviewAvailableParams {
    webview = 'webview',
    userID = 'userid'
}
enum WebviewSource {
    android = 'android',
    ios = 'ios'
}
